import { render, staticRenderFns } from "./RecebimentoDeNotaFiscalListView.vue?vue&type=template&id=2b42c19c&scoped=true"
import script from "./RecebimentoDeNotaFiscalListView.vue?vue&type=script&lang=js"
export * from "./RecebimentoDeNotaFiscalListView.vue?vue&type=script&lang=js"
import style0 from "./RecebimentoDeNotaFiscalListView.vue?vue&type=style&index=0&id=2b42c19c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b42c19c",
  null
  
)

export default component.exports